import React from 'react';

export function Card({
  variant = 'default', pad = 'md', title, description, actions, footer,
  interactive = false, children, className = '', ...rest
}) {
  const sectioned = title != null || footer != null;
  const cls = [
    'sp-card',
    variant !== 'default' && 'sp-card--' + variant,
    sectioned ? 'sp-card--flush' : 'sp-card--pad-' + pad,
    interactive && 'sp-card--interactive',
    className
  ].filter(Boolean).join(' ');
  if (!sectioned) return <div className={cls} {...rest}>{children}</div>;
  return (
    <div className={cls} {...rest}>
      {title != null && (
        <div className="sp-card__header">
          <div style={{ minWidth: 0 }}>
            <div className="sp-card__title">{title}</div>
            {description && <div className="sp-card__desc">{description}</div>}
          </div>
          {actions && <div style={{ display: 'flex', gap: 'var(--space-2)', flex: 'none' }}>{actions}</div>}
        </div>
      )}
      <div className="sp-card__body" style={pad === 'none' ? { padding: 0 } : undefined}>{children}</div>
      {footer && <div className="sp-card__footer">{footer}</div>}
    </div>
  );
}
